import { DisaggregatedMetric, MetricPanelProps } from "../../services/types";
import { getSortedMetrics, getSvgrMap } from "../../utils/dashboardUtils";
import MetricCard from "../MetricCard";
import BannerRibbon from "../BannerRibbon";
import RaceEthnicityBarChartCard from "../charts/RaceEthnicityBarChartCard";
import { useDashboardColor } from "../../context/DashboardColorContext";

const DemographicMetrics = ({ indicators, categorizedData, tab, geoDetails, geoTag, selectionActive }: MetricPanelProps) => {   
    const sortedMetrics = getSortedMetrics(tab, categorizedData);
    console.log("Demographic data:", sortedMetrics);
    const color = useDashboardColor();

    // Define metrics for order
    const demoOne: DisaggregatedMetric[] = sortedMetrics[0];
    const race = indicators?.find(i => i.id === 1247);
    const ethnicity = indicators?.find(i => i.id === 1072);

    if (!indicators || indicators.length === 0) {
        return <div className="flex items-center justify-center text-color-cai-dashboard">No metrics available for {tab}.</div>;
    }

    return (
        <div className="mx-auto px-4 pb-8 pt-4">
            <BannerRibbon text="People"/>
            
            <div className="grid grid-cols-2 gap-4">
                {demoOne?.map(metric => (
                    <MetricCard
                        key={metric.id}
                        metric={metric}
                        width="w-full"
                        svg={getSvgrMap(metric.id)}
                        disaggData={indicators}
                        geoDetails={geoDetails}
                        geoTag={geoTag}
                        selectionActive={selectionActive}
                    />
                ))}
            </div>

            {/* 🔹 NEW: Race & Ethnicity block */}
            {race && (
                <div className="col-span-2 w-full mt-4">
                    <RaceEthnicityBarChartCard
                        raceMetric={race}
                        ethnicityMetric={ethnicity}
                        disaggData={indicators}
                        geoDetails={geoDetails}
                        geoTag={geoTag}
                        selectionActive={selectionActive}
                        height="h-48"
                        background="bg-white"
                        barColor={color}
                    />
                </div>
            )}
        </div>
    );
}

export default DemographicMetrics;